import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { getLandingContent } from '@/mocks/landingData';

export default function NotFound() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const { notFound } = getLandingContent(i18n.language);
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">{notFound.title}</h1>
        <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-gray-500">{notFound.text}</p>
        <a href="/" className="mt-6 inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-white font-medium px-6 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap">
          {notFound.button}
          <i className="ri-home-line w-5 h-5 flex items-center justify-center"></i>
        </a>
      </div>
    </div>
  );
}
